import { render, staticRenderFns } from "./select-tags.vue?vue&type=template&id=445a3554&"
import script from "./select-tags.vue?vue&type=script&lang=js&"
export * from "./select-tags.vue?vue&type=script&lang=js&"
import style0 from "./select-tags.vue?vue&type=style&index=0&id=445a3554&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports